/**
 * Created by RaoMeng on 2018/11/14
 * Desc: 发布通知公告
 */

import React, {Component} from 'react'
import {Input, Button} from 'antd'
import 'css/announce.css'
import {Toast} from 'antd-mobile'
import TargetSelect from 'components/TargetSelect'
import UploadEnclosure from 'components/UploadEnclosure'
import {fetchGet, fetchPost, fetchPostObj} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {connect} from 'react-redux'
import {clearListState} from 'action/listState'

const {TextArea} = Input

class AnnounceRelease extends Component {

    constructor() {
        super()

        this.state = {
            announceTitle: '',
            announceContent: '',

            previewVisible: false,
            previewImage: '',
            fileList: [],
            targetList: [],
            targetCount: 0,
            targetData: [],
        }
    }

    componentDidMount() {
        document.title = '发布通知公告'

        this.getOrganization()
    }

    componentWillUnmount() {
        Toast.hide()

        clearTimeout(this.backTask)
    }

    render() {
        const {announceTitle, announceContent, targetCount, targetList, fileList, targetData} = this.state
        const targetProps = {
            targetData: targetData,
            targetValues: targetList,
            title: '通知对象',
            targetCount: targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this)
        }

        const defaultTargetProps = {
            targetData: [],
            targetValues: targetList,
            title: '通知对象',
            targetCount: targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this)
        }
        return (
            <div className='common-column-layout'>
                <div className='gray-line'></div>
                {targetData.length > 0 ? <TargetSelect {...targetProps}/>
                    : <TargetSelect {...defaultTargetProps}/>}
                <div className='gray-line'></div>
                <input className='titleInput' placeholder='请输入通知标题'
                       value={announceTitle} onChange={this.titleChange}/>
                <div className='gray-line' style={{height: '1px'}}></div>
                <TextArea className='contentInput' placeholder='请输入通知内容'
                          autosize={{minRows: 6, maxRows: 12}} value={announceContent}
                          onChange={this.contentChange}/>
                <div className='gray-line'></div>
                <UploadEnclosure
                    action={API.UPLOAD_FILE}
                    fileList={fileList}
                    count={9}
                    multiple={true}
                    beforeUpload={this.beforeUpload.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                />

                <Button className='commonButton' type='primary' style={{margin: '35px', borderRadius: 30}}
                        onClick={this.releaseAnnounce}>发布</Button>

                {/*<span className='announce-release-history'>历史发布</span>*/}
            </div>
        )
    }

    getOrganization = () => {
        Toast.loading('', 0)
        var role = this.props.userInfo.teacher.roleId===8?'管理员':'普通教师';
        fetchGet(API.GET_CLASS_LIST, {
            teacherId: this.props.userInfo.user.userFunId,
        }).then(response => {
            Toast.hide()
            const {targetData} = this.state, classData = [],teacher = [],parent = [];
            targetData.length = 0
            if (response && response.data) {
                response.data.forEach((dataObj, data_index) => {
                    classData.push({
                        classId: dataObj.clazzId,
                        classzName: dataObj.clazzName,
                        gradeName: dataObj.gradeName,
                        taskGradeid: dataObj.gradeId,
                        title: getStrValue(dataObj, 'gradeName') + getStrValue(dataObj, 'clazzName'),
                        value: `4-${data_index}` + getStrValue(dataObj, 'gradeName') + getStrValue(dataObj, 'clazzName'),
                        key: `4-${data_index}`,
                    })
                })

                if(role==="管理员") {
                    targetData.push({
                        title: '全体教师',
                        value: `2`,
                        key: `2`,
                        children: teacher,
                    }, {
                        title: '全体家长',
                        value: `0`,
                        key: `0`,
                        children: parent,
                    })
                }

                targetData.push({
                    title: '全部班级',
                    value: `4`,
                    key: `4`,
                    children: classData,
                })
            }
            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    releaseAnnounce = () => {
        if (this.isRequesting == true) {
            return
        }
        const {announceTitle, announceContent, fileList} = this.state

        if (isObjEmpty(announceTitle)) {
            Toast.fail('请输入通知标题')
            return
        }
        if (isObjEmpty(announceContent)) {
            Toast.fail('请输入通知内容')
            return
        }
        if (announceTitle.length > 50) {
            Toast.fail('通知标题过长')
            return
        }

        if (isObjEmpty(this.checkNodes)) {
            Toast.fail("请选择要通知的班级");
            return;
        }

        const fileUrls = []
        if (fileList) {
            fileList.forEach((value, index) => {
                if (value.status === 'uploading') {
                    Toast.fail('有附件正在上传，请稍候')
                    return
                }

                if (value.status === 'done') {
                    fileUrls.push(value.picUrl)
                }
            })
        }
        const classList = [];
        var target='';
        console.log('this.checkNodes',this.checkNodes)
        this.checkNodes.forEach((node, index) => {
            if(node.title==='全体教师'){
                target+='teacher,';
            }else if(node.title==='全体家长'){
                target+='parent,';
            }else{
                classList.push(node.classId)
            }
        })
        if(classList.length>0){
            target+='class,';
        }

        const paramObj = {
            notify_title: announceTitle,
            notify_details: announceContent,
            notify_status: 1,
            notify_target: target,
            notify_creator: this.props.userInfo.user.userFunId,
            creator: this.props.userInfo.user.userName,
            notify_targetId: classList.join(','),
            notify_files: JSON.stringify(fileUrls)
        }
        console.log('fileList', fileList)
        console.log('paramObj', paramObj)

        this.isRequesting = true
        Toast.loading('正在发布...', 0)
        fetchPostObj(API.NOTIFY_CREATE,
            paramObj,
            {"Content-Type": 'application/json;charset=UTF-8'})
            .then(response => {
                Toast.hide()
                Toast.success('发布成功', 1)
                clearListState()()

                this.setState({
                    announceTitle: '',
                    announceContent: '',
                    fileList: []
                })
                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }).catch(error => {
            this.isRequesting = false
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    }

    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes
        this.setState({
            targetList: value,
            targetCount: count
        });
    }

    titleChange = e => {
        this.setState({
            announceTitle: e.target.value
        })
    }

    contentChange = e => {
        this.setState({
            announceContent: e.target.value
        })
    }

    beforeUpload = (file, fileList) => {

    }

    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AnnounceRelease)
